<template>
	<div class="panel_shouyin">
		<!-- <div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
					<el-button @click="add" size="mini">新建</el-button>
				</el-col>
			</el-row>
		</div> -->
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column label="单号" prop="serviceId" >
				</el-table-column>
				<!-- <el-table-column label="顾客" prop="memberName" width="120">
				</el-table-column>
				<el-table-column label="宠物昵称" prop="petName" width="120">
				</el-table-column> -->
				<el-table-column label="类别" width="50">
					<template slot-scope="props">
						<div v-if="props.row.serviceTypeId===1">疫苗</div>
						<div v-if="props.row.serviceTypeId===2">驱虫</div>
					</template>
				</el-table-column>
				<el-table-column label="套餐名称" width="170" prop="servicePackageName">
				</el-table-column>
				<el-table-column label="计划名称" width="110" prop="planName">
				</el-table-column>
				<el-table-column label="实施计划" width="70" prop="planName">
					<template slot-scope="props">
						<div>
							<span>{{props.row.planIndex}}</span>/<span>{{props.row.planCount}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="计划时间" width="90">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.planDate,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="添加人" width="60" prop="createUserName">
				</el-table-column>
				<el-table-column label="支付状态" width="70">
					<template slot-scope="props">
						<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
						<div style="color:#FD4E4E" v-else>未支付</div>
					</template>
				</el-table-column>
				<el-table-column label="创建门店" width="70">
					<template slot-scope="props">
						<span v-if="props.row.shopId">{{$public.getShopNameById(props.row.shopId)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="执行门店" width="70">
					<template slot-scope="props">
						<span v-if="props.row.currShopId">{{$public.getShopNameById(props.row.currShopId)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="remark" width="60">
				</el-table-column>
				<el-table-column label="操作" width="60">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="seePet(props.row)">查看</el-button>
					</template>
				</el-table-column>
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<ymqcSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></ymqcSee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import ymqcSee from "../drawer/ymqcSee.vue"
	export default {
		components:{page,ymqcSee},
		data(){
			return{
				search:{
					keyword:'',
					serviceTypeId:0,
					isPay:-1,
					isEnter:-1,
					shopId:'',
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerJiyangPetSee_state:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			add(){
				this.$store.commit('ymqc/set_type','add')
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"keyword": '',
					petId:this.curPetId,
					"serviceTypeId": 0,  // 1疫苗；2驱虫; Default:0 
					"isPay": -1,          // -1 全部；0未支付；1已支付
					"petType": "",       //  猫类；犬类
					"status": 0,         // 1未完成；2已完成
					"isOut": 0,        // -1 0 1 2
					hasGoods:true,
					"desc": true,
					"shopId":'',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.post('/api/MedicalPackage/Plan/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			}
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;
	// padding:44px 0 0;
	box-sizing: border-box;overflow: auto;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		top:0;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
